var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, query } from 'lit/decorators.js';
import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { escapeRegExp, formatFileSize, replaceAll, } from '../../helpers/string.js';
import { fileDownloadSvg, minusSvg, plusSvg } from '../../helpers/elements.js';
let ElementB2bSearchResult = class ElementB2bSearchResult extends LitElement {
    highlightAndTruncateMatch() {
        const searchTerm = this.parent.autocomplete.input.value;
        let snippet = this.result.matchingValue;
        const regexp = new RegExp(`${escapeRegExp(searchTerm)}(?![^<>]*>)`, 'ig');
        const matchCallback = (match) => `<span class='font-bold bg-chm-light-gray'>${match}</span>`;
        snippet = replaceAll(snippet, '<b>', '');
        const highlightedText = snippet.replace(regexp, matchCallback);
        const matchIndex = snippet.toLowerCase().indexOf(searchTerm.toLowerCase());
        if (matchIndex === -1) {
            this.placeholder.textContent = snippet;
            return;
        }
        this.placeholderSpan.innerHTML = highlightedText;
        const highlightElement = this.placeholderSpan.querySelector('span');
        const containerWidth = this.placeholder.offsetWidth;
        const totalText = this.placeholderSpan.textContent;
        const highlightStart = highlightElement.offsetLeft;
        const highlightWidth = highlightElement.offsetWidth;
        const highlightCenter = highlightStart + highlightWidth / 2;
        const charactersPerPixel = totalText.length / this.placeholderSpan.offsetWidth;
        const visibleChars = Math.floor(containerWidth * charactersPerPixel);
        const halfVisible = Math.floor(visibleChars / 2);
        const highlightCharIndex = Math.floor(totalText.length * (highlightCenter / this.placeholderSpan.offsetWidth));
        let start = Math.max(0, highlightCharIndex - halfVisible);
        let end = start + visibleChars;
        if (end > totalText.length) {
            end = totalText.length;
            start = Math.max(0, end - visibleChars);
        }
        let visibleText = totalText.substring(start, end);
        if (start > 0)
            visibleText = '...' + visibleText;
        if (end < totalText.length)
            visibleText = visibleText + '...';
        visibleText = visibleText.replace(regexp, matchCallback);
        this.placeholderSpan.innerHTML = visibleText;
    }
    firstUpdated(_changedProperties) {
        this.updateComplete.then(() => {
            this.highlightAndTruncateMatch();
        });
        super.firstUpdated(_changedProperties);
    }
    render() {
        const addShowAllBtn = !this.parent.showAll && this.props['data-result-index'] === 7;
        const addShowLessBtn = this.parent.showAll &&
            this.props['data-result-index'] === this.parent.counter - 1;
        let title = this.result.title;
        if (this.result.fileSize) {
            title = html `<div
        class="flex flex-col gap-x-[16px] md:gap-x-[20px] xl:gap-x-[24px]"
      >
        ${this.result.pageTitle}
        <div class="flex items-center">
          ${fileDownloadSvg('fill-black w-[18px] h-[20px] mr-[8px]', this.result.fileType)}
          ${this.result.fileType?.toUpperCase()}${this.result.fileSize ? formatFileSize(this.result.fileSize) : ''}
        </div>
      </div>`;
        }
        return html `
      ${this.props['data-result-index'] > 0
            ? ''
            : html ` <li
              class="distinction py-[16px] md:py-[24px] xl:py-[32px] mt-[16px] md:mt-[24px] lg:mt-[32px] mx-[42px] sm:mx-[54px] mdxx:mx-[70px] flex items-center font-bold border-b-[1px] border-b-chm-light-gray"
            >
              ${this.parent.counter}
              Suchergebnisse
            </li>`}
      <li
        id="${this.props.id}"
        data-result-index="${this.props['data-result-index']}"
        role="${this.props.role}"
        tabindex="0"
        class="autocomplete-result md:search-result-m ${classMap({
            hidden: !this.parent.showAll && this.props['data-result-index'] > 7,
            'border-b-[1px]': !addShowAllBtn && !addShowLessBtn,
            'border-b-chm-light-gray': !addShowAllBtn && !addShowLessBtn,
        })} mx-[42px] cursor-pointer select-none text-search-result-s sm:mx-[54px] mdxx:mx-[70px]"
        @keydown="${(e) => {
            if (e.key === 'Enter')
                e.target.click();
        }}"
      >
        <div
          class="grid pt-[16px] pb-[20px] lg:pb-[24px] grid-cols-4 text-body-zero sm:text-sm-body md:grid-cols-8 md:text-md-body md:gap-x-2"
        >
          <div class="col-span-4 flex">
            <div class="flex flex-col w-full">
              <div class="matching-placeholder flex whitespace-nowrap w-full">
                <span></span>
              </div>
              <div class="md:hidden mt-[8px]">${title}</div>
            </div>
          </div>
          <div
            class="hidden md:col-span-3 md:col-start-6 md:block md:ml-[16px] lg:ml-[24px]"
          >
            ${title}
          </div>
        </div>
      </li>
      ${addShowAllBtn
            ? html ` <li
              tabindex="0"
              class="mx-[42px] flex pt-[16px] pb-[20px] lg:pb-[24px] cursor-pointer items-center text-url sm:mx-[54px] md:text-md-url mdxx:mx-[70px]"
              @click="${() => this.parent.onShowAll()}"
              @keydown="${(e) => {
                if (e.key === 'Enter')
                    this.parent.onShowAll();
            }}"
            >
              ${plusSvg('w-[18px] h-[18px] fill-chm-red mr-[11px]')}
              Alle zeigen
            </li>` : ''}
      ${addShowLessBtn
            ? html ` <li
              tabindex="0"
              class="mx-[42px] flex pt-[16px] pb-[20px] lg:pb-[24px] cursor-pointer items-center text-url sm:mx-[54px] md:text-md-url mdxx:mx-[70px]"
              @click="${() => this.parent.onShowLess()}"
              @keydown="${(e) => {
                if (e.key === 'Enter')
                    this.parent.onShowLess();
            }}"
            >
              ${minusSvg('w-[18px] h-[18px] fill-chm-red mr-[11px]')}
              Weniger zeigen
            </li>` : ''}
    `;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: Object })
], ElementB2bSearchResult.prototype, "result", void 0);
__decorate([
    property({ type: Object })
], ElementB2bSearchResult.prototype, "props", void 0);
__decorate([
    property({ type: Object })
], ElementB2bSearchResult.prototype, "parent", void 0);
__decorate([
    query('.matching-placeholder')
], ElementB2bSearchResult.prototype, "placeholder", void 0);
__decorate([
    query('.matching-placeholder > span')
], ElementB2bSearchResult.prototype, "placeholderSpan", void 0);
ElementB2bSearchResult = __decorate([
    customElement('element-b2b-search-result')
], ElementB2bSearchResult);
export { ElementB2bSearchResult };
//# sourceMappingURL=element-b2b-search-result.js.map